module.exports = __webpack_public_path__ + "static/404-588636c5abf3787df7df1d417a0ebc73.png";